// let ticking = false;
export default function () {
    return {
        videoSource: this.$persist(''),

        videoSources: null,

        init() {
            this.setVideoSources()
            this.$nextTick(() => {
                this.getRandomVideoNotEarlierPlayed()
            })
        },

        setVideoSources() {
            let sourcesString;
            const mediaQuery = window.matchMedia('(orientation:portrait)')
            if (mediaQuery.matches) {
                sourcesString = this.$el.dataset.portraitSources
            } else {
                sourcesString = this.$el.dataset.sources
            }
    
            this.videoSources = sourcesString.split(',')
        },

        getRandomVideoNotEarlierPlayed() {
            if(this.videoSources.length<2) {
                this.videoSource=this.videoSources[0];
                this.playVideo()
                return;
            }
            this.$el.classList.add('opacity-0')
            const notPlayingVideos = this.videoSources.filter(src => {
                if (src !== this.videoSource) return src
            })
            const randomInt = this.getRandomInt(0, notPlayingVideos.length - 1)
            this.videoSource = notPlayingVideos[randomInt]
            if (this.videoSource === undefined) {
                this.videoSource = notPlayingVideos[0]
            }
            this.playVideo()
        },

        onChangeVideo() {
            this.getRandomVideoNotEarlierPlayed()
        },

        async playVideo() {
            await this.$el.pause()
            try {
                await this.$el.play()
                setTimeout(() => {
                    this.$el.classList.remove('opacity-0')
                }, 500)
            } catch (error) {
                console.warn(error)
            }
        },

        /**
                   * Returns a random integer between min (inclusive) and max (inclusive).
                   * The value is no lower than min (or the next integer greater than min
                   * if min isn't an integer) and no greater than max (or the next integer
                   * lower than max if max isn't an integer).
                   * Using Math.round() will give you a non-uniform distribution!
                   */
        getRandomInt(min, max) {
            min = Math.ceil(min)
            max = Math.floor(max)
            return Math.floor(Math.random() * (max - min + 1)) + min
        }
    }
}
